/* ==========================================================================
   SNIPPET — Horizontal scroller
   Défilement horizontal d'une piste : flèches, drag à la souris et masquage
   automatique des contrôles quand il n'y a rien à faire défiler.

   Contrat : voir snippets/horizontal-scroller.liquid
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.hscrollBound === 'true') return;

    var track = root.querySelector('[data-hscroll-track]');
    if (!track) return;

    root.dataset.hscrollBound = 'true';

    var arrows = root.querySelector('[data-hscroll-arrows]');
    var leftBtn = root.querySelector('[data-hscroll-arrow="left"]');
    var rightBtn = root.querySelector('[data-hscroll-arrow="right"]');

    function step() {
      var explicit = parseInt(root.dataset.hscrollStep, 10);
      return explicit > 0 ? explicit : Math.round(track.clientWidth * 0.8);
    }

    function updateArrows() {
      var canScrollLeft = track.scrollLeft > 1;
      var canScrollRight = track.scrollLeft < track.scrollWidth - track.clientWidth - 1;

      if (leftBtn) leftBtn.hidden = !canScrollLeft;
      if (rightBtn) rightBtn.hidden = !canScrollRight;
      if (arrows) arrows.hidden = !canScrollLeft && !canScrollRight;
    }

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    /* Les images chargées après coup changent la largeur de la piste */
    window.addEventListener('load', updateArrows);
    updateArrows();

    if (leftBtn) {
      leftBtn.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (rightBtn) {
      rightBtn.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    /* --- Drag horizontal à la souris --- */
    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;
    var hasMoved = false;

    track.addEventListener('mousedown', function (event) {
      isDragging = true;
      hasMoved = false;
      startX = event.pageX;
      scrollStart = track.scrollLeft;
      track.classList.add('is-dragging');
      event.preventDefault();
    });

    document.addEventListener('mousemove', function (event) {
      if (!isDragging) return;
      var dx = event.pageX - startX;
      if (Math.abs(dx) > 3) hasMoved = true;
      track.scrollLeft = scrollStart - dx;
    });

    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
    });

    /* Un drag ne doit pas déclencher la navigation du lien survolé */
    track.addEventListener('click', function (event) {
      if (hasMoved) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
  }

  function initAll() {
    document.querySelectorAll('[data-hscroll]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Ré-initialisation après un re-render dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', initAll);
})();
